<template>
  <section class="block">
    <div class="table-header">
      <nav>
        <label>
          <font-awesome-icon icon="search" />
          <input type="text" placeholder="検索フィルター" v-model="filterString" />
        </label>
        <button @click="newItem" v-if="newUri !== ''">
          <span>{{ newCaption }}</span>
          <font-awesome-icon icon="plus-circle" />
        </button>
      </nav>
    </div>
    <GenericTable
      :items="sortedAccounts"
      :columns="columns"
      keyProp="slug"
      :sortAsc="sortAsc"
      @sort="sortByNo"
      :showIndex="true"
    >
      <template #email="{ item }">
        <a :href="`/accounts/${item.slug}`">{{ item.email }}</a>
      </template>
      <template #organizations="{ item }">
        {{ Array.isArray(item.organizations)   ? item.organizations.join(', ') : item.organizations }}
      </template>
    </GenericTable>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import router from '@/router';
import GenericTable, { TableColumn } from '@/components/GenericTable.vue';
import { AccountData } from '@/lib/account';

export default defineComponent({
  name: 'AccountTable',
  components: { GenericTable },
  props: {
    accounts: {
      type: Array as () => AccountData[],
      required: true,
    },
    showIndex: {
      type: Boolean,
      default: true
    },
    newUri: {
      type: String,
      default: '',
    },
    newCaption: {
      type: String,
      default: 'New',
    },
  },
  data() {
    return {
      filterString: '',
      sortAsc: true,
      columns: [
        { key: 'email', label: 'メールアドレス' },
        { key: 'first_name', label: '名' },
        { key: 'last_name', label: '姓' },
        { key: 'role_name', label: '役割' },
        { key: 'organizations', label: '組織' },
      ] as TableColumn[],
    };
  },
  computed: {
    filteredAccounts(): AccountData[] {
      return this.accounts.filter((account) => {
        const query = this.filterString.toLowerCase();
        return [
          account.first_name,
          account.last_name,
          account.email,
          account?.role_name,
          account?.organizations,
        ]
          .filter(Boolean)
          .some((field) => field?.toLowerCase().includes(query));
      });
    },
    sortedAccounts(): AccountData[] {
      const data = [...this.filteredAccounts];
      if (!this.sortAsc) data.reverse();
      return data;
    },
  },
  methods: {
    sortByNo() {
      this.sortAsc = !this.sortAsc;
    },
    newItem() {
      if (this.newUri) router.push(this.newUri);
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/assets/const.scss' as *;

.block {
  @media (min-width: $desktop) {
    padding: 0 40px;
  }

  caption {
    padding: 0 0 20px;

    nav {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    label {
      position: relative;
      border: 1px solid var(--bs-gray-400);
      border-radius: 5px;

      svg {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
        color: var(--bs-gray-400);
      }

      input {
        padding: 6px 12px 6px 32px;
        width: 240px;
      }
    }

    button {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 5px;

      span {
        order: -1;
        display: none;

        @media (min-width: $tablet) {
          display: inline;
        }
      }
    }
  }

  thead {
    background-color: var(--bs-gray-800);
    color: var(--bs-gray-200);
    cursor: pointer;

    th {
      user-select: none;
    }

    nav {
      position: relative;
      width: 1rem;
      height: 1rem;
      margin-left: 5px;
    }

  }

  tbody td a {
    color: var(--bs-primary);
    text-decoration: none;
  }

  .table-header {
    padding: 0 0 20px;

    nav {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    label {
      position: relative;
      border: 1px solid var(--bs-gray-400);
      border-radius: 5px;

      svg {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
        color: var(--bs-gray-400);
      }

      input {
        padding: 6px 12px 6px 32px;
        width: 240px;
      }
    }

    button {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 5px;

      span {
        order: -1;
        display: none;

        @media (min-width: $tablet) {
          display: inline;
        }
      }
    }
  }

  
}
</style>
